import { ButtonsGroup } from '@hungryroot/pho';
import { PeriodicityTypes } from '@hungryroot/rest-hooks';
interface Props {
  testid?: string;
  handleClick?: (option: number, productId?: number) => void;
  type?: 'basic' | 'card';
  selected?: PeriodicityTypes | null;
  productId: number;
  className?: string;
}

const periodicityOptions = [
  {
    label: 'Often',
    value: PeriodicityTypes.OFTEN,
  },
  {
    label: 'Sometimes',
    value: PeriodicityTypes.SOMETIMES,
  },
  {
    label: 'Never',
    value: PeriodicityTypes.NEVER,
  },
];

export function OSNButtons(props: Props) {
  const {
    testid,
    handleClick,
    selected: periodicityValue = null,
    type = 'basic',
    productId,
    className,
  } = props;

  return (
    <ButtonsGroup
      testid={testid}
      handleClick={(option) => {
        if (periodicityValue === option) return;
        handleClick && handleClick(option, productId);
      }}
      type={type}
      selected={periodicityValue}
      options={periodicityOptions}
      className={className}
    />
  );
}
